
const squareSize = "40px"

export function FrontendBotBlocker({ onClick }: { onClick: () => void }) {
  return <div css={{
    position: "fixed",
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div
      onClick={() => {
        onClick()
        window.location.reload()

      }}
      css={{
        padding: "12px",
        background: "#f7f7f7",
        borderRadius: "14px",
        display: "inline-flex",
        flexWrap: "wrap",
        flexDirection: "column",
        width: "auto",
        gap: "14px",
      }}>
      <div css={{

        fontSize: "20px",
        lineHeight: "1",
        whiteSpace: "nowrap",
      }}>Подтвердите, что Вы не робот</div>

      <div css={{

        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}>
        <div css={{

          width: squareSize,
          height: squareSize,
          border: "1px solid #000",
          borderRadius: "4px",
          cursor: "pointer",
          margin: "0px 0 0 0",
          animation: "spin 2s ease 1",
        }}></div >
        <div css={{
          fontSize: "30px",
          lineHeight: 1,
          margin: "0 0 0 0",
          whiteSpace: "nowrap"
        }}> Нажмите на квадрат</div >
      </div >
    </div >
  </div>
}